// extracted by mini-css-extract-plugin
export default {"error_popup":"ErrorPopUp_error_popup__56JUf"};